module.exports = __webpack_public_path__ + "static/media/IMG_0329.0afd91ee.JPG";